import { FC, ReactNode } from 'react';

interface TagProps {
  children: ReactNode;
  className?: string;
  size?: 'sm' | 'md' | 'lg';
  compact?: boolean;
}

export const Tag: FC<TagProps> = ({
  children,
  className = '',
  size = 'md',
  compact = false,
}) => {
  const sizeClasses = {
    sm: 'text-xs tracking-wider',
    md: 'text-sm tracking-widest',
    lg: 'text-base tracking-widest',
  };

  const paddingClasses = compact ? 'px-2 py-0.5' : 'px-3 py-1';

  return (
    <span
      className={`
      inline-block font-konexy font-light uppercase whitespace-nowrap
      ${paddingClasses} rounded-md backdrop-blur-md
      bg-zinc-900/30 text-white dark:bg-white/30 dark:text-white
      shadow-sm
      ${sizeClasses[size]}
      ${className}
    `}
    >
      {children}
    </span>
  );
};

export default Tag;
